export default __webpack_public_path__ + "static/media/croatia_act.71c22892.MP4";